export default __webpack_public_path__ + "assets/images/8c6314da859acb015e447b02545606e9.webp";